import React, { useEffect } from "react";
import { useSetRecoilState } from "recoil";
import { userProfile } from "recoil/atom";
import { getProfile } from "pages/signin/services";

const AuthProvider = ({ children }) => {
  const setUserProfile = useSetRecoilState(userProfile);

  useEffect(() => {
    const initialize = async () => {
      try {
        const res = await getProfile();
        console.log("res", res);
        if (res.user) {
          if (!res.user.role) {
            setUserProfile({
              user: undefined,
              isAuthenticated: false,
              isInitialize: true,
            });
          } else {
            setUserProfile({
              user: res.user,
              isAuthenticated: true,
              isInitialize: true,
            });
          }
        } else {
          setUserProfile({
            user: undefined,
            isAuthenticated: false,
            isInitialize: true,
          });
        }
      } catch (err) {
        setUserProfile({
          user: undefined,
          isAuthenticated: false,
          isInitialize: true,
        });
      }
    };

    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <>{children}</>;
};

export default AuthProvider;
